import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss';

import logo from '../../theme/assets/other/ftf_cabinet_logo.png';
import {useNavigate} from "react-router-dom";
import {
    classicLogin,
    classicLoginFailure, resetPassword,
    resetPasswordSuccess
} from "../../store/main/action";
import {useDispatch, useSelector} from "react-redux";
import {getResetCode, getResetCodeFailure, getResetCodeSuccess} from "../../store/cabinet/action";


const ResPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    const formErr = useSelector(store => store.main.resetPasswordStatusErr);
    const resetPasswordStatus = useSelector(store => store.main.resetPasswordStatus);

    const getResCodeStatus = useSelector(store => store.cabinet.getResCodeStatus);
    const getResCodeStatusErr = useSelector(store => store.cabinet.getResCodeStatusErr);

    console.log(getResCodeStatusErr)


    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [password_confirmation, setPassword_confirmation] = useState('');


    const sendFormHandler = useCallback(()=>{
        if (!getResCodeStatus){
            dispatch(getResetCode({email}));
        } else {
            dispatch(resetPassword({reset_code: code, password, password_confirmation, email}));
        }
    }, [dispatch, code, password, password_confirmation, email, getResCodeStatus])

    useEffect(() => {
        if (authStatus){
            navigate('/matrix');
        }
    }, [authStatus, navigate]);

    useEffect(() => {
        if (resetPasswordStatus){
            navigate('/sign-in');
            dispatch(getResetCodeSuccess(false))
            dispatch(resetPasswordSuccess(false));
        }
    }, [dispatch, navigate, resetPasswordStatus]);

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);
    
    return (
        <section className={`${Styles.container} ${Styles.pagePadding}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={Styles.posWrap}>
                    <div className={Styles.logoWrap}>
                        <div className={Styles.logoWrapIconWrap}>
                            <img src={logo} alt="F#ck the Fomo"/>
                        </div>
                        <div className={Styles.logoWrapText}>F#ck the Fomo</div>
                    </div>
                    {getResCodeStatus ?
                        <div className={Styles.formWrap}>
                            <div className={Styles.formTitle}>Reset your password</div>
                            <div className={Styles.formBox}>
                                <div className={`${Styles.inputWrap} ${formErr?.code ? Styles.inputWrapWithErr : null}`}>
                                    <div className={Styles.inputTitle}>Code</div>
                                    <input
                                        type="text"
                                        className={Styles.ftfBorderInput}
                                        placeholder="5464564"
                                        value={code}
                                        onChange={(e)=>{setCode(e.target.value)}}
                                        onKeyDown={(event)=>{
                                            if (formErr.code){
                                                delete formErr.code;
                                                dispatch(classicLoginFailure(formErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{formErr?.code ? formErr.code : null}</div>
                                </div>
                                <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                                    <div className={Styles.inputTitle}>Your password</div>
                                    <input
                                        type="password"
                                        className={Styles.ftfBorderInput}
                                        placeholder="********"
                                        value={password}
                                        onChange={(e)=>{setPassword(e.target.value)}}
                                        onKeyDown={(event)=>{
                                            if (formErr.password){
                                                delete formErr.password;
                                                dispatch(classicLoginFailure(formErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{formErr?.password?.[0] ? formErr.password[0] : null}</div>
                                </div>
                                <div className={`${Styles.inputWrap} ${formErr?.password_confirmation ? Styles.inputWrapWithErr : null}`}>
                                    <div className={Styles.inputTitle}>Your password</div>
                                    <input
                                        type="password"
                                        className={Styles.ftfBorderInput}
                                        placeholder="********"
                                        value={password_confirmation}
                                        onChange={(e)=>{setPassword_confirmation(e.target.value)}}
                                        onKeyDown={(event)=>{
                                            if (formErr.password_confirmation){
                                                delete formErr.password_confirmation;
                                                dispatch(classicLoginFailure(formErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{formErr?.password_confirmation?.[0] ? formErr.password_confirmation[0] : null}</div>
                                </div>
                            </div>
                            <div className={Styles.ftfBorderBtn} onClick={()=>{sendFormHandler()}}>Reset</div>
                        </div> :
                        <div className={Styles.formWrap}>
                            <div className={Styles.formTitle}>Reset your password</div>
                            <div className={Styles.formBox}>
                                <div className={`${Styles.inputWrap} ${getResCodeStatusErr?.email ? Styles.inputWrapWithErr : null}`}>
                                    <div className={Styles.inputTitle}>Your email</div>
                                    <input
                                        type="text"
                                        className={Styles.ftfBorderInput}
                                        placeholder="example@gmail.com"
                                        value={email}
                                        onChange={(e)=>{setEmail(e.target.value)}}
                                        onKeyDown={(event)=>{
                                            if (getResCodeStatusErr?.email){
                                                delete getResCodeStatusErr.email;
                                                dispatch(getResetCodeFailure(getResCodeStatusErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{getResCodeStatusErr?.email ? getResCodeStatusErr.email : null}</div>
                                </div>
                            </div>
                            <div className={Styles.ftfBorderBtn} onClick={()=>{sendFormHandler()}}>Get Code</div>
                        </div>
                    }

                    <div className={Styles.link}>Don't have an account yet? <span onClick={()=>{navigate('/sign-up')}}>Sign up</span></div>
                </div>
            </div>
        </section>
    );
};

export default ResPage;
